(function() {
  'use strict';

  // Obtain the browser's native, unpatched addEventListener.
  // The theme's w3 performance system overwrites
  // EventTarget.prototype.addEventListener globally, which prevents
  // click listeners registered through it from firing reliably.
  // A temporary hidden iframe provides a clean prototype reference.
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  var nativeAddEventListener = iframe.contentWindow.EventTarget.prototype.addEventListener;
  iframe.remove();

  function getText(el) {
    return el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function isNormalNavigation(e, anchor) {
    if (e.button !== 0) return false;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return false;
    var target = anchor.getAttribute('target');
    if (target && target !== '_self') return false;
    return true;
  }

  function navigate(href) {
    window.location = href;
  }

  nativeAddEventListener.call(document, 'click', function(e) {
    var anchor = e.target.closest('a[href]');
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (!href || href === '#') return;

    var data = null;

    // --- 1. SLIDESHOW ---
    var slideshowSection = anchor.closest('.shopify-section--slideshow');
    if (slideshowSection) {
      var slide = anchor.closest('.slideshow__slide') || anchor;
      var headingEl = slide.querySelector('[data-sequence="heading"]');
      var allSlides = slideshowSection.querySelectorAll('.slideshow__slide');
      var pos = 1;
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i] === slide || allSlides[i].contains(anchor)) { pos = i + 1; break; }
      }
      var promoName = getText(headingEl) || ('Slide ' + pos);
      var creativeSlot = 'slideshow_' + pos;
      data = {
        event: 'select_promotion',
        link_url: href,
        ecommerce: {
          promotion_name: promoName,
          creative_slot: creativeSlot,
          items: [{
            promotion_name: promoName,
            creative_slot: creativeSlot
          }]
        }
      };
    }

    // --- 2. MEDIA GRID ---
    if (!data) {
      var gridItem = anchor.closest('a.media-grid__item');
      if (gridItem) {
        var gridSection = gridItem.closest('.shopify-section--media-grid');
        var titleEl = gridItem.querySelector('.h3');
        var allItems = gridSection ? gridSection.querySelectorAll('a.media-grid__item') : [];
        var gPos = 1;
        for (var j = 0; j < allItems.length; j++) {
          if (allItems[j] === gridItem) { gPos = j + 1; break; }
        }
        var gPromoName = getText(titleEl) || ('Kachel ' + gPos);
        var gCreativeSlot = 'media_grid_' + gPos;
        data = {
          event: 'select_promotion',
          link_url: href,
          ecommerce: {
            promotion_name: gPromoName,
            creative_slot: gCreativeSlot,
            items: [{
              promotion_name: gPromoName,
              creative_slot: gCreativeSlot
            }]
          }
        };
      }
    }

    // --- 3. MULTI-COLUMN CTAs ---
    if (!data) {
      var mcSection = anchor.closest('.shopify-section--multi-column');
      if (mcSection && (anchor.classList.contains('button') || anchor.classList.contains('link'))) {
        var mcItem = anchor.closest('.multi-column__item');
        var mcTitle = mcItem ? mcItem.querySelector('.h3, h3') : null;
        var allMcItems = mcSection.querySelectorAll('.multi-column__item');
        var mPos = 1;
        for (var m = 0; m < allMcItems.length; m++) {
          if (allMcItems[m] === mcItem) { mPos = m + 1; break; }
        }
        var mPromoName = getText(mcTitle) || ('Column ' + mPos);
        var mCreativeSlot = 'multi_column_' + mPos;
        data = {
          event: 'select_promotion',
          link_url: href,
          ecommerce: {
            promotion_name: mPromoName,
            creative_slot: mCreativeSlot,
            items: [{
              promotion_name: mPromoName,
              creative_slot: mCreativeSlot
            }]
          }
        };
      }
    }

    // --- 4. VIDEO CTA ---
    if (!data) {
      var videoSection = anchor.closest('.shopify-section--video');
      if (videoSection && anchor.classList.contains('button')) {
        var videoHeading = videoSection.querySelector('.h4, h4');
        var vPromoName = getText(videoHeading) || 'Video CTA';
        var vCreativeSlot = 'video';
        data = {
          event: 'select_promotion',
          link_url: href,
          ecommerce: {
            promotion_name: vPromoName,
            creative_slot: vCreativeSlot,
            items: [{
              promotion_name: vPromoName,
              creative_slot: vCreativeSlot
            }]
          }
        };
      }
    }

    // --- 5. BESTSELLER / FEATURED COLLECTION ---
    if (!data) {
      var fcSection = anchor.closest('.shopify-section--featured-collection');
      if (fcSection) {
        var card = anchor.closest('product-card');
        if (card) {
          var titleAnchor = card.querySelector('.product-card__title a');
          var productName = getText(titleAnchor) || '';
          var productHandle = card.getAttribute('handle') || '';
          var allCards = fcSection.querySelectorAll('product-card');
          var cPos = 1;
          for (var c = 0; c < allCards.length; c++) {
            if (allCards[c] === card) { cPos = c + 1; break; }
          }
          data = {
            event: 'select_item',
            link_url: href,
            ecommerce: {
              item_list_name: 'home_bestseller',
              items: [{
                item_id: productHandle,
                item_name: productName,
                index: cPos
              }]
            }
          };
        }
      }
    }

    if (!data) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    if (isNormalNavigation(e, anchor)) {
      e.preventDefault();

      var navigated = false;
      function doNavigate() {
        if (navigated) return;
        navigated = true;
        navigate(href);
      }

      data.eventCallback = doNavigate;
      data.eventTimeout = 100;

      window.dataLayer.push(data);

      setTimeout(doNavigate, 150);
    } else {
      window.dataLayer.push(data);
    }

  }, true);
})();
